import {
  FlightSlicePickerModalContent,
  type FlightSlicePickerModalContentProps,
} from "@tenant/flights";
import { Dialog, DialogContent } from "@tenant/ui";

export interface FlightSlicePickerModalProps
  extends FlightSlicePickerModalContentProps {
  open: boolean;
  onClose: () => void;
}

export const FlightSlicePickerModal = (props: FlightSlicePickerModalProps) => {
  return (
    <Dialog open={props.open} onOpenChange={props.onClose}>
      <DialogContent asChild>
        <FlightSlicePickerModalContent {...props} />
      </DialogContent>
    </Dialog>
  );
};
